import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TBusinessHoursProps } from '../../types/dealerLocatorDetail.types';
import Picture from '../../../@shared/picture';
import './styles.scss';

const BusinessHoursAndCertificationsSection: FC<TBusinessHoursProps> = (props) => {
  const { t } = useTranslation();
  const { hasBusinessHours, businessHours, hasCertifications, certifications } = props;
  const tableRecords: JSX.Element[] = Object.keys(businessHours).map((day) => {
    return (
      <div key={day} className={'dealer-locator-detail__business-hours__table-row'}>
        <span className="dealer-locator-detail__business-hours__table-row__day">{t(day)}</span>
        <span>{businessHours[day][0]}</span>
        <span>{businessHours[day][1]}</span>
      </div>
    );
  });
  return (
    <section className="dealer-locator-detail__business-hours-section">
      {hasBusinessHours && (
        <div className="dealer-locator-detail__business-hours">
          <div className="dealer-locator-detail__business-hours__title">{t('cnhi-dealerLocatorBusinessHours')}</div>
          <div className="dealer-locator-detail__business-hours__table">{tableRecords}</div>
        </div>
      )}
      {hasCertifications && (
        <div className="dealer-locator-detail__certifications">
          <div className="dealer-locator-detail__certifications__title">{t('cnhi-dealerLocatorCertifications')}</div>
          <div className="dealer-locator-detail__certifications__awards-section">
            {certifications.map((cert) => (
              <Picture
                key={cert.designationName}
                productImageProps={{
                  desktopRendition: { url: cert?.imageUrl },
                  imageClassName: 'dealer-locator-detail__certifications__award',
                }}
              ></Picture>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default BusinessHoursAndCertificationsSection;
